import { BottomSheet } from '@new-components/elements';

import { BankAccountVerificationProps } from './types';
import FailedVerificationImage from '@assets/illustrations/failed-verification.png';
import { bankAccountVerificationCx } from './styles';
import { Typography } from '@julo-ui/react';

const BankAccountVerification = (props: BankAccountVerificationProps) => {
  const { onClose, isOpen } = props;

  return (
    <BottomSheet
      title='Konfirmasi Bank Gagal'
      display={isOpen}
      onClose={onClose}
      ctaText='Kembali'
    >
      <div className={bankAccountVerificationCx}>
        <img
          src={FailedVerificationImage}
          alt='Verifikasi Bank'
          className='illustration'
        />
        <Typography type='body' fontSize='16px' sx={{ marginBottom: '16px' }}>
          Ini beberapa alasan kenapa konfirmasi kamu gagal:
        </Typography>
        <ul>
          <li>
            Nama pemilik rekening tidak sama dengan nama pengguna di aplikasi
            GrabModal.
          </li>
          <li>Rekening belum terdaftar di akun Grab kamu</li>
          <li>Bank tidak aktif selama 3 bulan terakhir</li>
        </ul>
      </div>
    </BottomSheet>
  );
};

export default BankAccountVerification;
